// extracted by mini-css-extract-plugin
export var layoutContainer = "_40-0";
export var layoutContainerNoRounding = "_40-6";
export var layoutContainerOpen = "_40-5";
export var layoutContainerResizing = "_40-1";
export var mainContent = "_40-2";
export var resizeDivider = "_40-3";
export var slidePanel = "_40-4";